// extracted by mini-css-extract-plugin
export default {"formMaoin":"ProductFrom_formMaoin__+q7UF"};